import { __awaiter } from "tslib";
import React, { useCallback, useMemo, useState } from 'react';
import useTransitionState from '../../hooks/use-transition-state';
import { context } from './utils';
import Content from './content';
import Icon from './icon';
import Control from './control';
import SimpleControl from './simple.control';
const closingTimeout = 240;
export const Dropdown = ({ children, onToggle, dataTest }) => {
    const [opened, setOpened] = useState(false);
    const [control, registerControl] = useState();
    const [content, registerContent] = useState({ current: null });
    const [state, close] = useTransitionState(opened, { duration: closingTimeout });
    const toggle = useCallback((update) => __awaiter(void 0, void 0, void 0, function* () {
        const directCommand = typeof update === 'boolean';
        const nextState = directCommand ? update : !opened;
        if (!directCommand && opened && state === 'show') {
            yield close();
        }
        onToggle === null || onToggle === void 0 ? void 0 : onToggle(nextState);
        setOpened(nextState);
    }), [opened, close, state, onToggle]);
    const contextValue = useMemo(() => ({ opened, state, toggle, control, content, registerContent, registerControl, dataTest }), [opened, state, toggle, control, content, registerContent, registerControl, dataTest]);
    return React.createElement(context.Provider, { value: contextValue }, children);
};
Dropdown.Content = Content;
Dropdown.Control = Control;
Dropdown.SimpleControl = SimpleControl;
Dropdown.Icon = Icon;
//# sourceMappingURL=dropdown.js.map